import React, { forwardRef } from 'react';

import { CheckSmall } from '@rover/icons';
import { Flex, Text } from '@rover/kibble/core';
import { useTheme } from '@rover/kibble/themes';

import { SelectFieldOptionConfig } from './SelectField.common';

export type { SelectFieldOptionConfig as Option };

type SelectFieldOptionProps = {
  id: string;
  key: string;
  option: SelectFieldOptionConfig;
  isSelected: boolean;
  onClick: (option: SelectFieldOptionConfig) => void;
};

const SelectFieldOption = forwardRef<HTMLElement, SelectFieldOptionProps>(
  ({ id, option, isSelected, onClick: handleOptionClick, ...other }, ref) => {
    const theme = useTheme();
    const { background, colors } = theme;

    return (
      <Flex
        {...other}
        id={id}
        role="option"
        aria-selected={isSelected}
        htmlRef={ref}
        tabIndex="-1"
        padding="3x"
        background={isSelected ? 'accent_secondary' : 'primary'}
        onClick={() => handleOptionClick(option)}
        sx={{
          userSelect: 'none',
          '&:focus': {
            'box-shadow': `inset 0 0 0 2px ${colors.border.input_focus}`,
          },
          '&:focus-visible': {
            outline: 'none',
          },
          '@media (hover: hover)': {
            '&:hover': {
              background: background.interactive.button_primary_pressed,
            },
          },
        }}
      >
        <Flex flexGrow="1" mr="2x">
          <Text>{option.label}</Text>
        </Flex>
        <CheckSmall
          height="24px"
          width="24px"
          display={isSelected ? 'block' : 'none'}
          fill={colors.interactive_link.primary_base}
        />
      </Flex>
    );
  }
);

export default SelectFieldOption;
